var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSound(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 62,
    viewBox: "0 0 69 62",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M45.0435 16.4068C47.2451 18.0533 49.032 20.1883 50.2627 22.6427C51.4934 25.0971 52.1341 27.8035 52.1341 30.5476C52.1341 33.2917 51.4934 35.9982 50.2627 38.4526C49.032 40.907 47.2451 43.042 45.0435 44.6884M54.6158 5.80121C58.317 8.78368 61.3023 12.5539 63.3531 16.8357C65.4039 21.1175 66.4683 25.8025 66.4683 30.5476C66.4683 35.2927 65.4039 39.9777 63.3531 44.2595C61.3023 48.5414 58.317 52.3116 54.6158 55.294M13.1359 41.1532H6.04529C5.10502 41.1532 4.20326 40.7808 3.53839 40.1178C2.87352 39.4548 2.5 38.5556 2.5 37.618V23.4772C2.5 22.5396 2.87352 21.6404 3.53839 20.9775C4.20326 20.3145 5.10502 19.942 6.04529 19.942H13.1359L25.5444 4.03361C25.8543 3.43344 26.3692 2.96358 26.9962 2.70894C27.6231 2.4543 28.3207 2.43167 28.963 2.64513C29.6052 2.8586 30.1497 3.29408 30.498 3.8729C30.8464 4.45171 30.9756 5.13568 30.8624 5.80121V55.294C30.9756 55.9596 30.8464 56.6435 30.498 57.2223C30.1497 57.8012 29.6052 58.2366 28.963 58.4501C28.3207 58.6636 27.6231 58.6409 26.9962 58.3863C26.3692 58.1317 25.8543 57.6618 25.5444 57.0616L13.1359 41.1532Z",
    stroke: "#D6AF66",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSound);
export default __webpack_public_path__ + "static/media/sound.ddf3f579d467beeee5caa0867808c205.svg";
export { ForwardRef as ReactComponent };